import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M3 12l0 .01","key":"svg-0"}],["path",{"d":"M7 12l10 0","key":"svg-1"}],["path",{"d":"M21 12l0 .01","key":"svg-2"}]]

const IconSeparator = createReactComponent('outline', 'separator', 'Separator', __iconNode);

export default IconSeparator;